package com.evoapps.evoshift.ui.finance

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.ChevronLeft
import androidx.compose.material.icons.filled.ChevronRight
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.util.asString
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.selection.selectable
import androidx.compose.foundation.selection.selectableGroup
import androidx.compose.ui.draw.clip
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.clearAndSetSemantics
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.heading
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.comparison.Change
import com.evoapps.evoshift.domain.comparison.ComparisonMetric
import com.evoapps.evoshift.domain.comparison.DayComparison
import com.evoapps.evoshift.domain.comparison.SalesStatistics
import com.evoapps.evoshift.domain.comparison.StatisticsBase
import com.evoapps.evoshift.domain.comparison.StatisticsPeriodKind
import com.evoapps.evoshift.domain.comparison.StatisticsQuery
import com.evoapps.evoshift.domain.comparison.StatisticsSummary
import com.evoapps.evoshift.domain.comparison.WeekComparison
import com.evoapps.evoshift.domain.comparison.higherIsBetter
import com.evoapps.evoshift.domain.comparison.isAdditive
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.LocalDaySpecials
import com.evoapps.evoshift.ui.util.LocalDayWeather
import com.evoapps.evoshift.ui.util.SpecialDaysLine
import com.evoapps.evoshift.ui.util.WeatherAttribution
import com.evoapps.evoshift.ui.util.WeatherBadge
import com.evoapps.evoshift.ui.util.WeatherIcon
import com.evoapps.evoshift.ui.util.dayAndMonth
import com.evoapps.evoshift.ui.util.dayFull
import com.evoapps.evoshift.ui.util.dayShort
import com.evoapps.evoshift.ui.util.formatPercentOrDash
import com.evoapps.evoshift.ui.util.icon
import com.evoapps.evoshift.ui.util.monthName
import com.evoapps.evoshift.ui.util.specialDaysLine
import com.evoapps.evoshift.ui.util.weatherDescription
import com.evoapps.evoshift.viewmodels.StatisticsEvent
import com.evoapps.evoshift.viewmodels.StatisticsUiState
import com.evoapps.evoshift.viewmodels.StatisticsViewModel
import com.evoapps.evoshift.widgets.ComparisonChart
import com.evoapps.evoshift.widgets.ComparisonChartColours
import com.evoapps.evoshift.widgets.ComparisonSlot
import com.evoapps.evoshift.widgets.EvoDateRangePickerDialog
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.ErrorState
import com.evoapps.evoshift.widgets.LocalOnColours
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.comparisonDifferenceTag
import com.evoapps.evoshift.widgets.compactAmount
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.comparison_change
import evoshift.composeapp.generated.resources.comparison_days_compared
import evoshift.composeapp.generated.resources.comparison_fall
import evoshift.composeapp.generated.resources.comparison_holiday
import evoshift.composeapp.generated.resources.comparison_holiday_now
import evoshift.composeapp.generated.resources.comparison_holiday_then
import evoshift.composeapp.generated.resources.comparison_holidays_note
import evoshift.composeapp.generated.resources.comparison_like_for_like
import evoshift.composeapp.generated.resources.comparison_metric_labour
import evoshift.composeapp.generated.resources.comparison_metric_result
import evoshift.composeapp.generated.resources.comparison_metric_sales
import evoshift.composeapp.generated.resources.comparison_mode_last_year_date
import evoshift.composeapp.generated.resources.comparison_mode_last_year_weekday
import evoshift.composeapp.generated.resources.comparison_no_data
import evoshift.composeapp.generated.resources.comparison_no_last_year
import evoshift.composeapp.generated.resources.comparison_points
import evoshift.composeapp.generated.resources.comparison_previous_week
import evoshift.composeapp.generated.resources.comparison_rise
import evoshift.composeapp.generated.resources.comparison_shifted_day
import evoshift.composeapp.generated.resources.comparison_shifted_week
import evoshift.composeapp.generated.resources.comparison_this_period
import evoshift.composeapp.generated.resources.comparison_this_week
import evoshift.composeapp.generated.resources.comparison_week_over_week_title
import evoshift.composeapp.generated.resources.spmh
import evoshift.composeapp.generated.resources.statistics_average_day
import evoshift.composeapp.generated.resources.statistics_base_last_year
import evoshift.composeapp.generated.resources.statistics_base_previous
import evoshift.composeapp.generated.resources.statistics_best_day
import evoshift.composeapp.generated.resources.statistics_by_date
import evoshift.composeapp.generated.resources.statistics_by_weekday
import evoshift.composeapp.generated.resources.statistics_chart_description
import evoshift.composeapp.generated.resources.statistics_chart_title
import evoshift.composeapp.generated.resources.statistics_compare_with
import evoshift.composeapp.generated.resources.statistics_day_against
import evoshift.composeapp.generated.resources.statistics_days_with_takings
import evoshift.composeapp.generated.resources.statistics_markers_note
import evoshift.composeapp.generated.resources.statistics_metric
import evoshift.composeapp.generated.resources.statistics_metric_labour_cost
import evoshift.composeapp.generated.resources.statistics_move_back
import evoshift.composeapp.generated.resources.statistics_move_forward
import evoshift.composeapp.generated.resources.statistics_no_access
import evoshift.composeapp.generated.resources.statistics_no_counterpart
import evoshift.composeapp.generated.resources.statistics_no_previous
import evoshift.composeapp.generated.resources.statistics_no_takings
import evoshift.composeapp.generated.resources.statistics_period
import evoshift.composeapp.generated.resources.statistics_period_custom
import evoshift.composeapp.generated.resources.statistics_period_month
import evoshift.composeapp.generated.resources.statistics_period_week
import evoshift.composeapp.generated.resources.statistics_pick_range
import evoshift.composeapp.generated.resources.statistics_previous_month
import evoshift.composeapp.generated.resources.statistics_previous_period
import evoshift.composeapp.generated.resources.statistics_summary_title
import evoshift.composeapp.generated.resources.statistics_title
import evoshift.composeapp.generated.resources.statistics_total
import evoshift.composeapp.generated.resources.statistics_total_share
import evoshift.composeapp.generated.resources.statistics_weekday_header
import evoshift.composeapp.generated.resources.statistics_weekdays_title
import evoshift.composeapp.generated.resources.statistics_weeks_description
import evoshift.composeapp.generated.resources.statistics_worst_day
import kotlinx.datetime.LocalDate
import kotlinx.datetime.number
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource
import kotlin.math.abs
import kotlin.math.ceil

/*
 * SH-228: the Statistics screen (Money's bar → "Statystyki"): a week, a month or a range of dates
 * against the period before or the same period last year (by weekday, or by date), one figure at
 * a time (net sales first, then labour cost, labour share, SPMH and the daily result). It shows:
 * the period's summary (total, average per day, best and weakest day, the like-for-like change),
 * the days' bars with the comparison overlaid and the difference under them, each day's weather
 * and special day under its bar, the weeks against the week before, and each weekday's average.
 * A base with no takings says so ("Brak danych z zeszłego roku"), never 0. Money roles only.
 *
 * SH-252: on a tablet or a laptop the period's arrows head the screen with the choices in
 * segmented rows beside or under them, the summary's figures sit in a grid that fits the width,
 * the day chart takes the full width (up to today in a running period) and the weeks and weekdays
 * share the row under it. With nothing to compare the screen says so once (in the summary) and
 * leaves out the difference band and every "Zmiana".
 */

/** Test tags of the Statistics screen. */
object StatisticsTags {
    const val SUMMARY = "statistics_summary"
    const val DAY_CHART = "statistics_day_chart"
    const val WEEK_CHART = "statistics_week_chart"
    const val WEEKDAYS = "statistics_weekdays"
    const val PERIOD_LABEL = "statistics_period_label"
    const val CHANGE = "statistics_change"
    const val PICK_RANGE = "statistics_pick_range"
    /** SH-252: the period, comparison and figure choices. */
    const val CONTROLS = "statistics_controls"
    /** SH-252: the day chart's card (its readout above the bars). */
    const val DAY_CARD = "statistics_day_card"
    /** SH-252: the difference band under the day chart (drawn only when something is compared). */
    val DAY_DIFFERENCE = comparisonDifferenceTag(DAY_CHART)
    fun kind(kind: StatisticsPeriodKind) = "statistics_kind_${kind.name}"
    fun base(base: StatisticsBase) = "statistics_base_${base.name}"
    fun metric(metric: ComparisonMetric) = "statistics_metric_${metric.name}"
    fun alignment(byDate: Boolean) = "statistics_align_${if (byDate) "date" else "weekday"}"
}

/** The figures in the order the metric switch offers them (net sales first). */
val StatisticsMetrics = listOf(
    ComparisonMetric.NET_SALES, ComparisonMetric.LABOUR_COST, ComparisonMetric.LABOUR_PERCENT,
    ComparisonMetric.SPMH, ComparisonMetric.RESULT
)

fun statisticsMetricRes(metric: ComparisonMetric): StringResource = when (metric) {
    ComparisonMetric.NET_SALES -> Res.string.comparison_metric_sales
    ComparisonMetric.LABOUR_COST -> Res.string.statistics_metric_labour_cost
    ComparisonMetric.LABOUR_PERCENT -> Res.string.comparison_metric_labour
    ComparisonMetric.SPMH -> Res.string.spmh
    ComparisonMetric.RESULT -> Res.string.comparison_metric_result
}

fun statisticsKindRes(kind: StatisticsPeriodKind): StringResource = when (kind) {
    StatisticsPeriodKind.WEEK -> Res.string.statistics_period_week
    StatisticsPeriodKind.MONTH -> Res.string.statistics_period_month
    StatisticsPeriodKind.CUSTOM -> Res.string.statistics_period_custom
}

/** What the period is set against, in words ("Poprzedni tydzień", "Rok temu (dzień tygodnia)"). */
fun statisticsBaseLabelRes(query: StatisticsQuery): StringResource = when (query.base) {
    StatisticsBase.LAST_YEAR -> if (query.byCalendarDate) Res.string.comparison_mode_last_year_date else Res.string.comparison_mode_last_year_weekday
    StatisticsBase.PREVIOUS_PERIOD -> when (query.kind) {
        StatisticsPeriodKind.WEEK -> Res.string.comparison_previous_week
        StatisticsPeriodKind.MONTH -> Res.string.statistics_previous_month
        StatisticsPeriodKind.CUSTOM -> Res.string.statistics_previous_period
    }
}

/** "Brak danych z zeszłego roku" / "Brak danych z poprzedniego okresu". */
fun statisticsNoBaseRes(base: StatisticsBase): StringResource =
    if (base == StatisticsBase.LAST_YEAR) Res.string.comparison_no_last_year else Res.string.statistics_no_previous

/** A figure as the screen prints it: money, a share or money per hour; "-" without it. */
@Composable
fun statisticsValueText(metric: ComparisonMetric, value: Double?, currency: String): String = when (metric) {
    ComparisonMetric.NET_SALES, ComparisonMetric.LABOUR_COST, ComparisonMetric.RESULT -> value?.let { formatMoney(it, currency) } ?: "-"
    ComparisonMetric.LABOUR_PERCENT -> formatPercentOrDash(value)
    ComparisonMetric.SPMH -> formatSpmhOrDash(value, currency)
}

/** The change as the screen prints it: "+8,4%", for the labour share "−1,2 punktu procentowego"; null without one. */
@Composable
fun statisticsChangeText(metric: ComparisonMetric, change: Change): String? {
    if (metric == ComparisonMetric.LABOUR_PERCENT) {
        val points = change.absolute ?: return null
        return stringResource(Res.string.comparison_points, signOf(points) + formatDecimal(abs(points), 1, decimalSeparator = decimalSeparatorNow()))
    }
    return change.percent?.let(::formatSignedPercent)
}

private fun decimalSeparatorNow(): Char = if (com.evoapps.evoshift.util.usesDecimalComma(com.evoapps.evoshift.util.appLanguage())) ',' else '.'

/** The colour of a change: green when it is good for the business, red when it is not. */
@Composable
private fun changeColour(metric: ComparisonMetric, change: Change, neutral: Color): Color {
    val value = (if (metric == ComparisonMetric.LABOUR_PERCENT) change.absolute else change.percent) ?: return neutral
    val colours = LocalOnColours.current
    return when {
        abs(value) < 0.05 -> neutral
        (value > 0) == metric.higherIsBetter -> colours.success
        else -> colours.error
    }
}

/** "19 października – 25 października 2026", "Październik 2026". */
@Composable
fun statisticsPeriodLabel(query: StatisticsQuery): String {
    val period = query.period
    return when {
        query.kind == StatisticsPeriodKind.MONTH -> "${monthName(period.start.month.number)} ${period.start.year}"
        period.start == period.end -> "${dayAndMonth(period.start)} ${period.start.year}"
        period.start.year == period.end.year -> "${dayAndMonth(period.start)} – ${dayAndMonth(period.end)} ${period.end.year}"
        else -> "${dayAndMonth(period.start)} ${period.start.year} – ${dayAndMonth(period.end)} ${period.end.year}"
    }
}

/** "Czw 22.10" */
@Composable
private fun shortDate(date: LocalDate) = "${dayShort(date.dayOfWeek)} ${date.day}.${date.month.number.toString().padStart(2, '0')}"

/** "22.10.2025" */
private fun fullDate(date: LocalDate) = "${date.day}.${date.month.number.toString().padStart(2, '0')}.${date.year}"

/** "6.04" */
private fun dayMonth(date: LocalDate) = "${date.day}.${date.month.number.toString().padStart(2, '0')}"

/** Labels every n-th slot so they never overlap (about 24dp per label). */
private fun labelStep(width: Dp, slots: Int): Int =
    if (slots == 0) 1 else ceil(24.0 / ((width.value - 76) / slots).coerceAtLeast(1f)).toInt().coerceAtLeast(1)

/** The chart's axis: amounts shortened ("4,5 tys."), shares and money per hour as numbers. */
private fun axisFormat(metric: ComparisonMetric): (Double) -> String = when (metric) {
    ComparisonMetric.LABOUR_PERCENT -> { v -> "${v.toInt()}%" }
    else -> ::compactAmount
}

@Composable
fun StatisticsScreen(viewModel: StatisticsViewModel, onNavigateBack: () -> Unit) {
    val state by viewModel.uiState.collectAsState()
    Scaffold(
        containerColor = Cream,
        topBar = { EvoTopBar(title = stringResource(Res.string.statistics_title), onBack = onNavigateBack) }
    ) { padding ->
        val loadError = state.loadError
        when {
            // SH-247: the screen's shape (its controls, figures and charts) until it is known.
            !state.checked -> StatisticsPlaceholder(controls = true, modifier = Modifier.padding(padding))
            // The Money screen's gate: no money, no statistics (nothing was read).
            !state.allowed -> Box(Modifier.fillMaxSize().padding(padding).padding(24.dp), contentAlignment = Alignment.Center) {
                Text(stringResource(Res.string.statistics_no_access), textAlign = TextAlign.Center, color = DeepNavy)
            }
            loadError != null && state.records.isEmpty() ->
                ErrorState(loadError, onRetry = { viewModel.onEvent(StatisticsEvent.Retry) }, modifier = Modifier.padding(padding))
            state.query == null -> StatisticsPlaceholder(controls = true, modifier = Modifier.padding(padding))
            else -> CompositionLocalProvider(
                LocalDayWeather provides state.weather,
                LocalDaySpecials provides state.specialDays
            ) {
                StatisticsContent(state, viewModel::onEvent, Modifier.padding(padding))
            }
        }
    }
}

@Composable
private fun StatisticsContent(state: StatisticsUiState, onEvent: (StatisticsEvent) -> Unit, modifier: Modifier) {
    val query = state.query ?: return
    val statistics = state.statistics
    val widthClass = LocalWindowWidthClass.current
    // SH-252: a tablet (in portrait too) or a laptop: the roomy header, the grid and the wide chart.
    val roomy = !widthClass.isCompact
    Column(
        modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .contentWidth(widthClass.wideContentMaxWidth)
            .padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        if (roomy) RoomyControls(state, query, onEvent) else StatisticsControls(state, query, onEvent)
        if (state.isLoading) LinearProgressIndicator(Modifier.fillMaxWidth())
        state.loadError?.let { Text(it.asString(), color = MaterialTheme.colorScheme.error) }
        if (statistics == null || !state.ready) {
            // SH-247: the figures and charts on their way, as placeholders under the controls.
            if (state.loadError == null) StatisticsPlaceholder(controls = false, scroll = false)
            return@Column
        }

        val summary = statistics.summary(state.metric)
        val today = state.today
        // SH-252: a period running into the future is drawn up to today (the days to come have nothing yet).
        val days = statistics.days.filter { today == null || it.date <= today }.ifEmpty { statistics.days }
        val weeks = statistics.weeks.filter { today == null || it.week.start <= today }.ifEmpty { statistics.weeks }
        SummaryCard(summary, query, state.currency, large = roomy)
        DayChartCard(statistics, days, summary.baseMissing, state.metric, state.currency, today, height = if (roomy) 240.dp else 180.dp)
        if (widthClass.isExpanded) {
            // A tablet in landscape, a laptop: the weeks and the weekdays side by side under the chart.
            Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                Box(Modifier.weight(1f)) { WeekChartCard(weeks, state.metric, state.currency, today) }
                Box(Modifier.weight(1f)) { WeekdaysCard(statistics, state.metric, query, state.currency, summary.baseMissing) }
            }
        } else {
            WeekChartCard(weeks, state.metric, state.currency, today)
            WeekdaysCard(statistics, state.metric, query, state.currency, summary.baseMissing)
        }
        Notes(statistics)
        if (state.weather.isNotEmpty()) {
            WeatherAttribution(com.evoapps.evoshift.domain.model.DayWeather.sourcesOf(state.weather.values))
        }
    }
}

@Composable
private fun SectionCard(title: String, modifier: Modifier = Modifier, content: @Composable () -> Unit) {
    RegularCard(modifier = modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp)) {
            Text(
                title, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = DeepNavy,
                modifier = Modifier.semantics { heading() }
            )
            Spacer(Modifier.height(10.dp))
            content()
        }
    }
}

@Composable
private fun StatisticsChip(label: String, selected: Boolean, tag: String, onClick: () -> Unit) {
    FilterChip(
        selected = selected,
        onClick = onClick,
        label = { Text(label) },
        colors = FilterChipDefaults.filterChipColors(
            labelColor = DeepNavy,
            selectedContainerColor = DeepNavy,
            selectedLabelColor = Color.White
        ),
        modifier = Modifier.handCursor().testTag(tag)
    )
}

/** A group of chips in one line, scrolled sideways on a phone (the controls stay short). */
@Composable
private fun ChipLine(content: @Composable androidx.compose.foundation.layout.RowScope.() -> Unit) {
    Row(
        Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically,
        content = content
    )
}

/** The period (kind, arrows, dates), the base and the figure. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun StatisticsControls(state: StatisticsUiState, query: StatisticsQuery, onEvent: (StatisticsEvent) -> Unit) {
    var picking by rememberSaveable { mutableStateOf(false) }
    val muted = DeepNavy.copy(alpha = 0.65f)
    RegularCard(modifier = Modifier.fillMaxWidth().testTag(StatisticsTags.CONTROLS)) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            state.workplace?.name?.takeIf { it.isNotBlank() }?.let {
                Text(it, style = MaterialTheme.typography.labelMedium, color = muted)
            }
            Text(stringResource(Res.string.statistics_period), style = MaterialTheme.typography.labelMedium, color = muted)
            ChipLine {
                StatisticsPeriodKind.entries.forEach { kind ->
                    StatisticsChip(stringResource(statisticsKindRes(kind)), kind == state.kind, StatisticsTags.kind(kind)) {
                        if (kind == StatisticsPeriodKind.CUSTOM && state.kind == StatisticsPeriodKind.CUSTOM) picking = true
                        else onEvent(StatisticsEvent.SelectKind(kind))
                    }
                }
            }
            Row(verticalAlignment = Alignment.CenterVertically) {
                IconButtonWithTooltip(onClick = { onEvent(StatisticsEvent.Move(-1)) }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.statistics_move_back)) {
                    Icon(Icons.Default.ChevronLeft, contentDescription = stringResource(Res.string.statistics_move_back), tint = DeepNavy)
                }
                Text(
                    statisticsPeriodLabel(query),
                    style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = DeepNavy,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.weight(1f).testTag(StatisticsTags.PERIOD_LABEL)
                )
                IconButtonWithTooltip(
                    onClick = { onEvent(StatisticsEvent.Move(1)) },
                    enabled = state.canGoForward,
                    modifier = Modifier.handCursor(),
                    tooltip = stringResource(Res.string.statistics_move_forward)
                ) {
                    Icon(
                        Icons.Default.ChevronRight, contentDescription = stringResource(Res.string.statistics_move_forward),
                        tint = DeepNavy.copy(alpha = if (state.canGoForward) 1f else 0.3f)
                    )
                }
                IconButtonWithTooltip(onClick = { picking = true }, modifier = Modifier.handCursor().testTag(StatisticsTags.PICK_RANGE), tooltip = stringResource(Res.string.statistics_pick_range)) {
                    Icon(Icons.Default.CalendarMonth, contentDescription = stringResource(Res.string.statistics_pick_range), tint = DeepNavy)
                }
            }
            Text(stringResource(Res.string.statistics_compare_with), style = MaterialTheme.typography.labelMedium, color = muted)
            ChipLine {
                StatisticsBase.entries.forEach { base ->
                    val label = if (base == StatisticsBase.LAST_YEAR) Res.string.statistics_base_last_year else Res.string.statistics_base_previous
                    StatisticsChip(stringResource(label), base == state.base, StatisticsTags.base(base)) { onEvent(StatisticsEvent.SelectBase(base)) }
                }
            }
            if (state.base == StatisticsBase.LAST_YEAR) {
                ChipLine {
                    StatisticsChip(stringResource(Res.string.statistics_by_weekday), !state.byCalendarDate, StatisticsTags.alignment(false)) {
                        onEvent(StatisticsEvent.SetByCalendarDate(false))
                    }
                    StatisticsChip(stringResource(Res.string.statistics_by_date), state.byCalendarDate, StatisticsTags.alignment(true)) {
                        onEvent(StatisticsEvent.SetByCalendarDate(true))
                    }
                }
            }
            Text(stringResource(Res.string.statistics_metric), style = MaterialTheme.typography.labelMedium, color = muted)
            ChipLine {
                StatisticsMetrics.forEach { metric ->
                    StatisticsChip(stringResource(statisticsMetricRes(metric)), metric == state.metric, StatisticsTags.metric(metric)) {
                        onEvent(StatisticsEvent.SelectMetric(metric))
                    }
                }
            }
        }
    }
    if (picking) RangePicker(state, query, onEvent) { picking = false }
}

@Composable
private fun RangePicker(state: StatisticsUiState, query: StatisticsQuery, onEvent: (StatisticsEvent) -> Unit, onDone: () -> Unit) {
    EvoDateRangePickerDialog(
        start = query.period.start,
        end = query.period.end,
        title = stringResource(Res.string.statistics_pick_range),
        onPick = { start, end ->
            onDone()
            onEvent(StatisticsEvent.SetCustomRange(start, end))
        },
        onDismiss = onDone,
        allowed = state.today?.let { LocalDate(it.year - 3, 1, 1)..it }
    )
}

/** The arrows, the period's name and the calendar: the screen's heading. */
@Composable
private fun PeriodNavigator(state: StatisticsUiState, query: StatisticsQuery, onEvent: (StatisticsEvent) -> Unit, onPick: () -> Unit, modifier: Modifier = Modifier) {
    Row(modifier, verticalAlignment = Alignment.CenterVertically) {
        IconButtonWithTooltip(onClick = { onEvent(StatisticsEvent.Move(-1)) }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.statistics_move_back)) {
            Icon(Icons.Default.ChevronLeft, contentDescription = stringResource(Res.string.statistics_move_back), tint = DeepNavy)
        }
        Text(
            statisticsPeriodLabel(query),
            style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold, color = DeepNavy,
            modifier = Modifier.padding(horizontal = 4.dp).testTag(StatisticsTags.PERIOD_LABEL).semantics { heading() }
        )
        IconButtonWithTooltip(onClick = { onEvent(StatisticsEvent.Move(1)) }, enabled = state.canGoForward, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.statistics_move_forward)) {
            Icon(
                Icons.Default.ChevronRight, contentDescription = stringResource(Res.string.statistics_move_forward),
                tint = DeepNavy.copy(alpha = if (state.canGoForward) 1f else 0.3f)
            )
        }
        IconButtonWithTooltip(onClick = onPick, modifier = Modifier.handCursor().testTag(StatisticsTags.PICK_RANGE), tooltip = stringResource(Res.string.statistics_pick_range)) {
            Icon(Icons.Default.CalendarMonth, contentDescription = stringResource(Res.string.statistics_pick_range), tint = DeepNavy)
        }
    }
}

/** One labelled group of the roomy controls ([label] null: lined up under its neighbours' labels). */
@Composable
private fun ControlGroup(label: String?, content: @Composable () -> Unit) {
    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
        label?.let { Text(it, style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.65f)) }
        content()
    }
}

/**
 * Options side by side as one segmented row, each as wide as its own label (Material's segmented
 * row makes every segment as wide as the others and cuts the long Polish labels), each tagged for
 * the robots and selectable like a radio button.
 */
@Composable
private fun <T> Segmented(options: List<T>, selected: T, label: @Composable (T) -> String, tag: (T) -> String, onSelect: (T) -> Unit) {
    val shape = RoundedCornerShape(10.dp)
    val line = DeepNavy.copy(alpha = 0.3f)
    Row(
        Modifier.height(IntrinsicSize.Min).clip(shape).border(1.dp, line, shape).selectableGroup(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        options.forEachIndexed { index, option ->
            val on = option == selected
            if (index > 0) Box(Modifier.width(1.dp).fillMaxHeight().background(line))
            Box(
                Modifier
                    .heightIn(min = 40.dp)
                    .background(if (on) DeepNavy else Color.Transparent)
                    .selectable(selected = on, role = Role.RadioButton, onClick = { onSelect(option) })
                    .handCursor()
                    .testTag(tag(option))
                    .padding(horizontal = 14.dp, vertical = 8.dp),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    label(option), style = MaterialTheme.typography.labelLarge, maxLines = 1,
                    color = if (on) Color.White else DeepNavy, fontWeight = if (on) FontWeight.Bold else FontWeight.Normal
                )
            }
        }
    }
}

/**
 * SH-252: a tablet's or a laptop's controls: the period's arrows and name as the heading (the
 * workplace beside it), then the period, the comparison and the figure as segmented rows that
 * wrap into a second line only when the window is narrow.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun RoomyControls(state: StatisticsUiState, query: StatisticsQuery, onEvent: (StatisticsEvent) -> Unit) {
    var picking by rememberSaveable { mutableStateOf(false) }
    RegularCard(modifier = Modifier.fillMaxWidth().testTag(StatisticsTags.CONTROLS)) {
        Column(Modifier.padding(horizontal = 16.dp, vertical = 12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween, modifier = Modifier.fillMaxWidth()) {
                PeriodNavigator(state, query, onEvent, onPick = { picking = true })
                state.workplace?.name?.takeIf { it.isNotBlank() }?.let {
                    Text(
                        it, style = MaterialTheme.typography.titleSmall, color = DeepNavy.copy(alpha = 0.65f), textAlign = TextAlign.End,
                        modifier = Modifier.weight(1f, fill = false).padding(start = 12.dp)
                    )
                }
            }
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(24.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp),
                itemVerticalAlignment = Alignment.Bottom
            ) {
                ControlGroup(stringResource(Res.string.statistics_period)) {
                    Segmented(StatisticsPeriodKind.entries, state.kind, { stringResource(statisticsKindRes(it)) }, StatisticsTags::kind) { kind ->
                        if (kind == StatisticsPeriodKind.CUSTOM && state.kind == StatisticsPeriodKind.CUSTOM) picking = true
                        else onEvent(StatisticsEvent.SelectKind(kind))
                    }
                }
                ControlGroup(stringResource(Res.string.statistics_compare_with)) {
                    Segmented(
                        StatisticsBase.entries, state.base,
                        { stringResource(if (it == StatisticsBase.LAST_YEAR) Res.string.statistics_base_last_year else Res.string.statistics_base_previous) },
                        StatisticsTags::base
                    ) { onEvent(StatisticsEvent.SelectBase(it)) }
                }
                if (state.base == StatisticsBase.LAST_YEAR) {
                    ControlGroup(null) {
                        Segmented(
                            listOf(false, true), state.byCalendarDate,
                            { stringResource(if (it) Res.string.statistics_by_date else Res.string.statistics_by_weekday) },
                            StatisticsTags::alignment
                        ) { onEvent(StatisticsEvent.SetByCalendarDate(it)) }
                    }
                }
                ControlGroup(stringResource(Res.string.statistics_metric)) {
                    Segmented(StatisticsMetrics, state.metric, { stringResource(statisticsMetricRes(it)) }, StatisticsTags::metric) {
                        onEvent(StatisticsEvent.SelectMetric(it))
                    }
                }
            }
        }
    }
    if (picking) RangePicker(state, query, onEvent) { picking = false }
}

/** One labelled figure of the summary: a tile of the grid (its text wraps rather than runs out). */
@Composable
private fun SummaryFigure(
    label: String, value: String, modifier: Modifier = Modifier, notes: List<String> = emptyList(),
    valueColor: Color = DeepNavy, large: Boolean = false
) {
    Column(modifier) {
        Text(label, style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.65f))
        Text(
            value, style = if (large) MaterialTheme.typography.titleLarge else MaterialTheme.typography.titleMedium,
            fontWeight = FontWeight.Bold, color = valueColor
        )
        notes.forEach { Text(it, style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.65f)) }
    }
}

/** SH-252: [tiles] in as many equal columns as fit [minTileWidth] each (two on a phone, up to five on a laptop). */
@Composable
private fun TileGrid(tiles: List<@Composable (Modifier) -> Unit>, minTileWidth: Dp, gap: Dp = 16.dp) {
    if (tiles.isEmpty()) return
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val columns = ((maxWidth + gap) / (minTileWidth + gap)).toInt().coerceIn(1, tiles.size)
        Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
            tiles.chunked(columns).forEach { row ->
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(gap)) {
                    row.forEach { tile -> tile(Modifier.weight(1f)) }
                    repeat(columns - row.size) { Spacer(Modifier.weight(1f)) }
                }
            }
        }
    }
}

/**
 * The period's total, average per day, best and weakest day and the like-for-like change, as a
 * grid of figures. Nothing to compare: one sentence instead of the change (the only place it is said).
 */
@Composable
private fun SummaryCard(summary: StatisticsSummary, query: StatisticsQuery, currency: String, large: Boolean) {
    val metric = summary.metric
    val metricName = stringResource(statisticsMetricRes(metric))
    SectionCard("${stringResource(Res.string.statistics_summary_title)}: $metricName", Modifier.testTag(StatisticsTags.SUMMARY)) {
        val muted = DeepNavy.copy(alpha = 0.65f)
        Text(
            stringResource(Res.string.statistics_days_with_takings, summary.tradedDays, summary.periodDays),
            style = MaterialTheme.typography.bodySmall, color = muted
        )
        Spacer(Modifier.height(10.dp))
        if (summary.tradedDays == 0) {
            Text(stringResource(Res.string.statistics_no_takings), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = DeepNavy)
            return@SectionCard
        }
        val baseLabel = stringResource(statisticsBaseLabelRes(query))
        val tiles = mutableListOf<@Composable (Modifier) -> Unit>()
        val total = stringResource(if (metric.isAdditive) Res.string.statistics_total else Res.string.statistics_total_share)
        tiles += { m -> SummaryFigure(total, statisticsValueText(metric, summary.total, currency), m, large = large) }
        summary.averagePerDay?.let { average ->
            tiles += { m -> SummaryFigure(stringResource(Res.string.statistics_average_day), statisticsValueText(metric, average, currency), m, large = large) }
        }
        summary.best?.let { best ->
            tiles += { m -> SummaryFigure(stringResource(Res.string.statistics_best_day), statisticsValueText(metric, best.value, currency), m, listOf(shortDate(best.date)), large = large) }
        }
        summary.worst?.takeIf { summary.tradedDays > 1 }?.let { worst ->
            tiles += { m -> SummaryFigure(stringResource(Res.string.statistics_worst_day), statisticsValueText(metric, worst.value, currency), m, listOf(shortDate(worst.date)), large = large) }
        }
        if (!summary.baseMissing) {
            val change = summary.change
            tiles += { m ->
                val changeText = statisticsChangeText(metric, change) ?: stringResource(Res.string.comparison_no_data)
                SummaryFigure(
                    "${stringResource(Res.string.comparison_change)} · $baseLabel", changeText, m.testTag(StatisticsTags.CHANGE),
                    notes = listOf(
                        "${stringResource(Res.string.comparison_this_period)}: ${statisticsValueText(metric, change.current, currency)}",
                        "$baseLabel: ${statisticsValueText(metric, change.base, currency)}"
                    ),
                    valueColor = changeColour(metric, change, DeepNavy), large = large
                )
            }
        }
        TileGrid(tiles, minTileWidth = if (large) 170.dp else 140.dp)
        Spacer(Modifier.height(12.dp))
        HorizontalDivider(color = DeepNavy.copy(alpha = 0.12f))
        Spacer(Modifier.height(10.dp))
        if (summary.baseMissing) {
            // Honest: no figure at all rather than a 0 or a 100% rise; said here once for the whole screen.
            Text(
                stringResource(statisticsNoBaseRes(query.base)),
                style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = DeepNavy,
                modifier = Modifier.testTag(StatisticsTags.CHANGE)
            )
        } else {
            Text(
                pluralStringResource(Res.plurals.comparison_days_compared, summary.tradedDays, summary.comparedDays, summary.tradedDays),
                style = MaterialTheme.typography.bodySmall, color = muted
            )
        }
    }
}

/** The days' bars with the base overlaid and the difference under them; each day's weather and special day under its bar. */
@Composable
private fun DayChartCard(
    statistics: SalesStatistics, days: List<DayComparison>, noComparison: Boolean, metric: ComparisonMetric, currency: String,
    today: LocalDate?, height: Dp
) {
    val colours = ComparisonChartColours.current
    val query = statistics.query
    val metricName = stringResource(statisticsMetricRes(metric))
    val baseLabel = stringResource(statisticsBaseLabelRes(query))
    val thisLabel = stringResource(Res.string.comparison_this_period)
    val weather = LocalDayWeather.current
    val specials = LocalDaySpecials.current
    SectionCard(stringResource(Res.string.statistics_chart_title, metricName), Modifier.testTag(StatisticsTags.DAY_CARD)) {
        val slots = days.map { day ->
            val change = day.change(metric)
            ComparisonSlot(
                label = day.date.day.toString(),
                current = day.current?.value(metric),
                base = if (day.compared) day.base?.value(metric) else day.base?.takeIf { it.hasTakings }?.value(metric),
                difference = change.absolute,
                changePercent = change.percent,
                marked = day.holiday || day.baseHoliday
            )
        }
        // The last day with takings (today is usually still open), else today.
        val selection = days.indexOfLast { it.current?.hasTakings == true }.takeIf { it >= 0 }
            ?: today?.let { t -> days.indexOfFirst { it.date == t } }?.takeIf { it >= 0 }
        val hasMarkers = days.any { weather[it.date.toString()] != null || specials[it.date.toString()] != null }
        BoxWithConstraints {
            val slotWidth = (maxWidth - 52.dp) / days.size.coerceAtLeast(1)
            val marker: (@Composable (Int) -> Unit)? = if (hasMarkers) { i -> DayMarker(days[i].date, slotWidth) } else null
            ComparisonChart(
                slots = slots,
                currentLabel = thisLabel,
                baseLabel = baseLabel,
                riseLabel = stringResource(Res.string.comparison_rise),
                fallLabel = stringResource(Res.string.comparison_fall),
                markedLabel = stringResource(Res.string.comparison_holiday),
                description = stringResource(Res.string.statistics_chart_description, metricName, baseLabel),
                axisFormat = axisFormat(metric),
                changeFormat = ::formatSignedPercent,
                colours = colours,
                initialSelection = selection,
                labelEvery = labelStep(maxWidth, slots.size),
                height = height,
                testTag = StatisticsTags.DAY_CHART,
                slotMarker = marker
            ) { i -> DayReadout(days[i], metric, query, currency, noComparison) }
        }
        if (hasMarkers) {
            Spacer(Modifier.height(6.dp))
            Text(stringResource(Res.string.statistics_markers_note), style = MaterialTheme.typography.bodySmall, color = colours.axis)
        }
    }
}

/** Under a day's bar: its special day's icon, else its weather's (read out with the day's line). */
@Composable
private fun DayMarker(date: LocalDate, slotWidth: Dp) {
    val special = LocalDaySpecials.current[date.toString()]
    val weather = LocalDayWeather.current[date.toString()]
    val size = (slotWidth - 2.dp).coerceIn(8.dp, 14.dp)
    val description = listOfNotNull(weather?.let { weatherDescription(it) }, special?.let { specialDaysLine(it) }).joinToString(", ")
    CompositionLocalProvider(LocalContentColor provides ComparisonChartColours.current.axis) {
        Box(Modifier.clearAndSetSemantics { if (description.isNotEmpty()) contentDescription = "${dayMonth(date)}: $description" }) {
            when {
                special != null -> Icon(special.primary.icon(), contentDescription = null, modifier = Modifier.size(size))
                weather?.shown != null -> WeatherIcon(weather.shown?.condition, size = size)
                else -> Spacer(Modifier.size(size))
            }
        }
    }
}

/** The picked day: its figure against its counterpart's, the difference, holidays, weather and special days. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun DayReadout(day: DayComparison, metric: ComparisonMetric, query: StatisticsQuery, currency: String, noComparison: Boolean) {
    val colours = ComparisonChartColours.current
    val counterpart = query.counterpart(day.date)
    val baseLabel = stringResource(statisticsBaseLabelRes(query))
    val against = when {
        counterpart == null -> stringResource(Res.string.statistics_no_counterpart)
        query.base == StatisticsBase.LAST_YEAR -> fullDate(counterpart.date)
        else -> shortDate(counterpart.date)
    }
    val noData = stringResource(Res.string.comparison_no_data)
    Column {
        val change = day.change(metric)
        val current = day.current?.value(metric)
        val base = day.base?.takeIf { it.hasTakings }?.value(metric)
        // SH-252: nothing compared in the whole period: the day alone (the summary says why, once).
        Text(
            if (noComparison && base == null) dayFull(day.date.dayOfWeek) + " " + dayMonth(day.date)
            else stringResource(Res.string.statistics_day_against, shortDate(day.date), baseLabel, against),
            style = MaterialTheme.typography.labelMedium, color = colours.axis
        )
        FlowRow(horizontalArrangement = Arrangement.spacedBy(16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            ReadoutFigure(stringResource(Res.string.comparison_this_period), current?.let { statisticsValueText(metric, it, currency) } ?: noData, colours.current)
            if (!noComparison || base != null) {
                ReadoutFigure(baseLabel, base?.let { statisticsValueText(metric, it, currency) } ?: noData, colours.base)
            }
            if (!noComparison) {
                val difference = change.absolute
                val differenceText = when {
                    difference == null -> noData
                    metric == ComparisonMetric.LABOUR_PERCENT -> statisticsChangeText(metric, change) ?: noData
                    metric == ComparisonMetric.SPMH -> signOf(difference) + formatSpmhOrDash(abs(difference), currency) + (change.percent?.let { " (${formatSignedPercent(it)})" } ?: "")
                    else -> formatSignedMoney(difference, currency) + (change.percent?.let { " (${formatSignedPercent(it)})" } ?: "")
                }
                ReadoutFigure(stringResource(Res.string.comparison_change), differenceText, changeColour(metric, change, colours.axis))
            }
        }
        val holidays = listOfNotNull(
            stringResource(Res.string.comparison_holiday_now).takeIf { day.holiday },
            stringResource(Res.string.comparison_holiday_then).takeIf { day.baseHoliday }
        )
        if (holidays.isNotEmpty()) Text(holidays.joinToString(" · "), style = MaterialTheme.typography.labelSmall, color = colours.axis)
        // SH-226/SH-227: the day's weather and special days.
        CompositionLocalProvider(LocalContentColor provides colours.axis) {
            LocalDayWeather.current[day.date.toString()]?.let { WeatherBadge(it, range = true, markForecast = true) }
            LocalDaySpecials.current[day.date.toString()]?.let { SpecialDaysLine(it) }
        }
    }
}

@Composable
private fun ReadoutFigure(label: String, value: String, colour: Color) {
    Column {
        Text(label, style = MaterialTheme.typography.labelSmall, color = ComparisonChartColours.current.axis)
        Text(value, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = colour, softWrap = false)
    }
}

/** Each week over the period against the week before, like for like, with the change over each pair. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun WeekChartCard(weeks: List<WeekComparison>, metric: ComparisonMetric, currency: String, today: LocalDate?) {
    if (weeks.isEmpty()) return
    val colours = ComparisonChartColours.current
    val thisLabel = stringResource(Res.string.comparison_this_week)
    val previousLabel = stringResource(Res.string.comparison_previous_week)
    val metricName = stringResource(statisticsMetricRes(metric))
    SectionCard(stringResource(Res.string.comparison_week_over_week_title)) {
        val slots = weeks.map { week ->
            val change = week.comparison.change(metric)
            ComparisonSlot(
                label = dayMonth(week.week.start),
                current = change.current,
                base = change.base,
                difference = change.absolute,
                changePercent = if (metric == ComparisonMetric.LABOUR_PERCENT) change.absolute else change.percent,
                marked = week.comparison.holidays.isNotEmpty()
            )
        }
        val selection = remember(weeks, today) { today?.let { t -> weeks.indexOfFirst { t in it.week } }?.takeIf { it >= 0 } }
        ComparisonChart(
            slots = slots,
            currentLabel = thisLabel,
            baseLabel = previousLabel,
            riseLabel = stringResource(Res.string.comparison_rise),
            fallLabel = stringResource(Res.string.comparison_fall),
            markedLabel = stringResource(Res.string.comparison_holiday),
            description = stringResource(Res.string.statistics_weeks_description, metricName),
            axisFormat = axisFormat(metric),
            changeFormat = if (metric == ComparisonMetric.LABOUR_PERCENT) { v -> signOf(v) + formatDecimal(abs(v), 1, decimalSeparator = decimalSeparatorNow()) } else ::formatSignedPercent,
            colours = colours,
            changeLabels = true,
            initialSelection = selection,
            height = 170.dp,
            testTag = StatisticsTags.WEEK_CHART
        ) { i ->
            val week = weeks[i]
            val change = week.comparison.change(metric)
            val noData = stringResource(Res.string.comparison_no_data)
            Column {
                Text(
                    "${dayMonth(week.week.start)}–${dayMonth(week.week.end)} · " +
                        pluralStringResource(Res.plurals.comparison_days_compared, week.comparison.periodDays, week.comparison.comparedDays, week.comparison.periodDays),
                    style = MaterialTheme.typography.labelMedium, color = colours.axis
                )
                FlowRow(horizontalArrangement = Arrangement.spacedBy(16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    ReadoutFigure(thisLabel, change.current?.let { statisticsValueText(metric, it, currency) } ?: noData, colours.current)
                    ReadoutFigure(previousLabel, change.base?.let { statisticsValueText(metric, it, currency) } ?: noData, colours.base)
                    ReadoutFigure(stringResource(Res.string.comparison_change), statisticsChangeText(metric, change) ?: noData, changeColour(metric, change, colours.axis))
                }
            }
        }
    }
}

/**
 * Each weekday's average in the period, against the base's, with the change. SH-252: nothing to
 * compare, the averages alone; a narrow card writes the days short ("Pn") so every column fits.
 */
@Composable
private fun WeekdaysCard(statistics: SalesStatistics, metric: ComparisonMetric, query: StatisticsQuery, currency: String, noComparison: Boolean) {
    val rows = statistics.weekdays(metric)
    val muted = DeepNavy.copy(alpha = 0.65f)
    val baseLabel = stringResource(statisticsBaseLabelRes(query))
    val noData = stringResource(Res.string.comparison_no_data)
    SectionCard(stringResource(Res.string.statistics_weekdays_title, stringResource(statisticsMetricRes(metric))), Modifier.testTag(StatisticsTags.WEEKDAYS)) {
        BoxWithConstraints(Modifier.fillMaxWidth()) {
            val short = !noComparison && maxWidth < 420.dp
            val header = MaterialTheme.typography.labelSmall
            val cell = if (short) MaterialTheme.typography.bodySmall else MaterialTheme.typography.bodyMedium
            val dayWeight = if (short) 0.6f else 1.1f
            Column {
                Row(Modifier.fillMaxWidth().padding(bottom = 4.dp), horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.Bottom) {
                    Text(stringResource(Res.string.statistics_weekday_header), Modifier.weight(dayWeight), style = header, color = muted)
                    Text(stringResource(Res.string.comparison_this_period), Modifier.weight(1f), style = header, color = muted, textAlign = TextAlign.End)
                    if (!noComparison) {
                        Text(baseLabel, Modifier.weight(1f), style = header, color = muted, textAlign = TextAlign.End)
                        Text(stringResource(Res.string.comparison_change), Modifier.weight(0.8f), style = header, color = muted, textAlign = TextAlign.End)
                    }
                }
                HorizontalDivider(color = DeepNavy.copy(alpha = 0.12f))
                rows.forEach { row ->
                    val dayName = dayFull(row.dayOfWeek)
                    val current = row.current?.let { statisticsValueText(metric, it, currency) } ?: "-"
                    val base = row.base?.let { statisticsValueText(metric, it, currency) } ?: "-"
                    val changeText = statisticsChangeText(metric, row.change)
                    val spoken = if (noComparison) "$dayName: ${row.current?.let { current } ?: noData}"
                    else "$dayName: $current, $baseLabel: ${row.base?.let { base } ?: noData}" + (changeText?.let { ", $it" } ?: "")
                    Row(
                        Modifier.fillMaxWidth().padding(vertical = 6.dp).clearAndSetSemantics { contentDescription = spoken },
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(if (short) dayShort(row.dayOfWeek) else dayName, Modifier.weight(dayWeight), style = cell, color = DeepNavy)
                        Text(current, Modifier.weight(1f), style = cell, fontWeight = FontWeight.Bold, color = DeepNavy, textAlign = TextAlign.End)
                        if (!noComparison) {
                            Text(base, Modifier.weight(1f), style = cell, color = ComparisonChartColours.current.base, textAlign = TextAlign.End)
                            Text(
                                changeText ?: "-", Modifier.weight(0.8f), style = cell, fontWeight = FontWeight.Bold,
                                color = changeColour(metric, row.change, muted), textAlign = TextAlign.End
                            )
                        }
                    }
                }
            }
        }
    }
}

/** Like for like, the holidays among the days, and the days that had to move (week 53, 29 February). */
@Composable
private fun Notes(statistics: SalesStatistics) {
    val colour = DeepNavy.copy(alpha = 0.65f)
    val style = MaterialTheme.typography.bodySmall
    val days = statistics.days
    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
        Text(stringResource(Res.string.comparison_like_for_like), style = style, color = colour)
        val holidays = days.flatMap { day ->
            listOfNotNull(dayMonth(day.date).takeIf { day.holiday }, fullDate(day.counterpart.date).takeIf { day.baseHoliday })
        }.distinct()
        if (holidays.isNotEmpty()) Text(stringResource(Res.string.comparison_holidays_note, holidays.joinToString(", ")), style = style, color = colour)
        if (days.any { it.counterpart.shiftedWeek }) Text(stringResource(Res.string.comparison_shifted_week), style = style, color = colour)
        if (days.any { it.counterpart.shiftedDay }) Text(stringResource(Res.string.comparison_shifted_day), style = style, color = colour)
    }
}

/**
 * SH-247: the statistics on their way: the period and metric chips ([controls]), the summary's
 * figures and the two charts as placeholders; side by side on wide windows like the content.
 */
@Composable
private fun StatisticsPlaceholder(controls: Boolean, modifier: Modifier = Modifier, scroll: Boolean = true) {
    val wide = LocalWindowWidthClass.current.isExpanded
    com.evoapps.evoshift.widgets.SkeletonArea(
        modifier
            .fillMaxWidth()
            .then(if (scroll) Modifier.fillMaxSize().verticalScroll(rememberScrollState()).contentWidth(LocalWindowWidthClass.current.wideContentMaxWidth).padding(16.dp) else Modifier)
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
            if (controls) {
                RegularCard(Modifier.fillMaxWidth()) {
                    Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        com.evoapps.evoshift.widgets.SkeletonText(style = MaterialTheme.typography.titleMedium, widthFraction = 0.5f)
                        repeat(2) {
                            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                repeat(3) { com.evoapps.evoshift.widgets.SkeletonBlock(Modifier.width(88.dp).height(32.dp), androidx.compose.foundation.shape.RoundedCornerShape(8.dp)) }
                            }
                        }
                    }
                }
            }
            val figures: @Composable () -> Unit = {
                RegularCard(Modifier.fillMaxWidth()) {
                    Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        com.evoapps.evoshift.widgets.SkeletonText(style = MaterialTheme.typography.titleMedium, widthFraction = 0.4f)
                        com.evoapps.evoshift.widgets.SkeletonBlock(Modifier.width(140.dp).height(36.dp))
                        com.evoapps.evoshift.widgets.SkeletonText(lines = 3, widthFraction = 0.85f)
                    }
                }
            }
            val chart: @Composable () -> Unit = {
                RegularCard(Modifier.fillMaxWidth()) {
                    Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        com.evoapps.evoshift.widgets.SkeletonText(style = MaterialTheme.typography.titleMedium, widthFraction = 0.45f)
                        com.evoapps.evoshift.widgets.SkeletonBlock(Modifier.fillMaxWidth().height(200.dp))
                    }
                }
            }
            if (wide) {
                Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                    Column(Modifier.weight(1.5f), verticalArrangement = Arrangement.spacedBy(16.dp)) { chart(); chart() }

                    Column(Modifier.weight(1f)) { figures() }
                }
            } else {
                figures()
                chart()
                chart()
            }
        }
    }
}
